module.exports = __webpack_public_path__ + "fonts/Inter-600-greek-ext41.2329210.woff2";